export function getElementPath(node) {
    let pathArray = [];

    pathArray.push(node.className);

    if (node.parentElement) {
        pathArray = pathArray.concat(getElementPath(node.parentElement));
    }

    return pathArray;
}
